import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusColor'
})
export class StatusColorPipe implements PipeTransform {

  transform(startIn?: number, duration?: number): string {
    if (startIn == null) return '#cccccc'; // default/fallback

    // Finished if more days have passed than frac duration
    if (startIn < 0 && duration != null && -startIn >= duration) {
      return '#6e6e6e'; // Finished → Steel Grey
    }

    // Operating (In Progress)
    if (startIn < 0 || startIn === 0) {
      return '#04AC66'; // Green (Replaces old teal)
    }

    if (startIn <= 7) {
      return '#ff6600'; // Next 7 Days (Orange)
    }
    if (startIn <= 30) {
      return '#ffae00'; // Next 8–30 Days (Yellow)
    }
    if (startIn <= 60) {
      return '#8197f2'; // 31–60 (Lavender)
    }
    return '#6ec2f7'; // 61–90 (Light Blue)
  }
}
